import { render, staticRenderFns } from "./resiExample.vue?vue&type=template&id=a4f140ca&scoped=true"
import script from "./resiExample.vue?vue&type=script&lang=js"
export * from "./resiExample.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4f140ca",
  null
  
)

export default component.exports